import { Component, Input, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { Webcam } from '../models/webcam.model';
import { BusinessSummary } from '../models/business-summary.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { AirportService } from '../airport.service';
import { EditWebcamComponent } from '../edit-webcam/edit-webcam.component';
import { DeleteWebcamComponent } from '../delete-webcam/delete-webcam.component';


@Component({
  selector: 'app-airport-webcams',
  templateUrl: './airport-webcams.component.html',
  styleUrls: ['./airport-webcams.component.scss']
})
export class AirportWebcamsComponent implements OnInit {
  @Input() airport: Airport;
  editModeSet: boolean;

  constructor(private _toggleService: EditToggleService,
              public _snackBar: MatSnackBar,
              private _editWebcamDialog: MatDialog,
              private _deleteWebcamDialog: MatDialog,
              private _airportService: AirportService) { }

  ngOnInit() {
    this.editModeSet = this._toggleService.getState();
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  webcamUrl(url: string): string {
    const website = url || '';
    if (url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
      return url;
    } else {
      return 'http://' + url;
    }
  }

  hasFboWebcams(): boolean {
    let retVal = false;
    this.airport.businesses.forEach((business) => {
      if (business.webcams.length > 0) {
        retVal = true;
      }
    });
    return retVal;
  }

  getFboWebcams(business: BusinessSummary): Webcam[] {
    let fboWebcams: Webcam[];
    fboWebcams = [];
    if (business.webcams.length > 0) {
      business.webcams.forEach( (businessWebcam) => {
        fboWebcams.push(businessWebcam);
      });
    }
    return fboWebcams;
  }

  async reloadAirport(identifier: string) {
    this.airport = await this._airportService.getAirport(identifier, true);
  }

  openEditWebcamDialog(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      airID: this.airport.airportId,
      webcam: null,
      isNew: false,
    };
    index == null ? dialogConfig.data.isNew = true : dialogConfig.data.webcam = this.airport.webcams[index];
    dialogConfig.data['airID'] = this.airport.airportId;
    dialogConfig.width = '60%';
    const dialogRef = this._editWebcamDialog.open(EditWebcamComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      this.reloadAirport(this.airport.identifier);
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        if (isUpdated.isNew) {
          // this.airport.pilotControlledLighting.push(isUpdated.pcl);
          // this.reloadAirport(this.airport.identifier);
          this._snackBar.open('Webcam', 'Added', {
            duration: 2000
          });
        } else {
          this._snackBar.open('Webcam', 'Updated', {
            duration: 2000
          });
        }
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  deleteWebcam(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      airportID: this.airport.airportId,
      webcamId: this.airport.webcams[index].webcamId
    };
    const dialogRef = this._deleteWebcamDialog.open(DeleteWebcamComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this._snackBar.open('Webcam', 'Deleted', {
          duration: 2000
        });
        // this.airport.localAttractions.splice(index, 1);
        this.reloadAirport(this.airport.identifier);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
